import { Box, CircularProgress, Skeleton, Stack, Typography } from "@mui/material";

function DropDownLoading(param) {
    return (
        <Box>
            <Typography variant="body1" color="secondary" className="align_text">
                <CircularProgress size={20} color="secondary" /> &nbsp; {param.title}
            </Typography>
            <br />
            <Stack spacing={1}>
                <Skeleton variant="rectangular" width={"100%"} height={20} />
                <Skeleton variant="rectangular" width={"100%"} height={30} />
                <Skeleton variant="rectangular" width={"100%"} height={30} />
                <Skeleton variant="rectangular" width={"100%"} height={20} />
            </Stack>
        </Box>
    );
}

export default DropDownLoading;
